<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_314" data-name="Group 314" transform="translate(-315.731 -280.286)">
    <circle id="Ellipse_231" data-name="Ellipse 231" cx="35.201" cy="35.201" r="35.201" transform="translate(315.731 280.286)" fill="#fff"/>
    <g id="Group_293" data-name="Group 293" transform="translate(-1133.858)">
      <path id="Path_465" data-name="Path 465" d="M1488.715,324.813c1.877-2.634,2.674-6.5.6-8.888a2.719,2.719,0,0,0-.514-3.1l-4.01-4.01a2.725,2.725,0,0,0-3.844,0l-.061.06a2.726,2.726,0,0,0,0,3.844l4.01,4.011a2.719,2.719,0,0,0,2.839.626c1.686,1.967.35,5.346-1.67,7.456H1461.8v3.874h45.934v-3.874Z" fill="#1a1818"/>
      <path id="Path_466" data-name="Path 466" d="M1481.63,316.522l-2.236-2.261-.045-.045-.157-.159.015-.014a5.015,5.015,0,0,1-1.069-1.935,9.03,9.03,0,0,0-2.884-1.316,5.853,5.853,0,0,0,.653-.384c.085-.055.163-.118.244-.177.139-.1.271-.213.4-.328a6.246,6.246,0,1,0-8.875-.813c.065.082.131.163.2.242.13.145.261.286.4.419a6.151,6.151,0,0,0,.578.476c.082.06.16.123.245.179a6.276,6.276,0,0,0,.659.386c-4.083,1.056-7.188,4.678-7.764,11.729h21.03A18.805,18.805,0,0,0,1481.63,316.522Z" fill="#1a1818"/>
      <path id="Path_467" data-name="Path 467" d="M1492.467,309.332c.13.145.261.286.4.419a6.135,6.135,0,0,0,.578.476c.082.06.16.123.245.179a6.276,6.276,0,0,0,.659.386,9.018,9.018,0,0,0-3.122,1.475,4.954,4.954,0,0,1,.885,2.481,9.441,9.441,0,0,1,.656,7.773h14.84c-.577-7.051-3.682-10.673-7.764-11.729a5.84,5.84,0,0,0,.652-.384c.085-.055.163-.118.244-.177.139-.1.271-.213.4-.328a6.246,6.246,0,1,0-8.875-.813C1492.332,309.172,1492.4,309.253,1492.467,309.332Z" fill="#1a1818"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_01_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_01_03.vue